import { DirectiveOptions,  DirectiveFunction} from 'vue/types/umd';
import { VBTooltip } from 'bootstrap-vue';

export const AbcTooltip = VBTooltip;
